var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 6621,
    transform: "translate(-870 -6374)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 309,
    transform: "translate(-870 -62)",
    fill: "#13373F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0038 4.95683C5.73238 4.95683 3.90023 6.76035 3.90023 8.99628C3.90023 11.2322 5.73238 13.0357 8.0038 13.0357C10.2752 13.0357 12.1074 11.2322 12.1074 8.99628C12.1074 6.76035 10.2752 4.95683 8.0038 4.95683ZM8.0038 11.6225C6.53595 11.6225 5.33595 10.4447 5.33595 8.99628C5.33595 7.54785 6.53238 6.37011 8.0038 6.37011C9.47523 6.37011 10.6717 7.54785 10.6717 8.99628C10.6717 10.4447 9.47166 11.6225 8.0038 11.6225ZM13.2324 4.7916C13.2324 5.31543 12.8038 5.73379 12.2752 5.73379C11.7431 5.73379 11.3181 5.31191 11.3181 4.7916C11.3181 4.27129 11.7467 3.84941 12.2752 3.84941C12.8038 3.84941 13.2324 4.27129 13.2324 4.7916ZM15.9502 5.74785C15.8895 4.48574 15.5967 3.36777 14.6574 2.44668C13.7217 1.52559 12.5859 1.2373 11.3038 1.17402C9.98237 1.1002 6.02166 1.1002 4.70023 1.17402C3.42166 1.23379 2.28595 1.52207 1.34666 2.44316C0.40738 3.36426 0.118094 4.48222 0.0538086 5.74433C-0.0211914 7.04511 -0.0211914 10.9439 0.0538086 12.2447C0.114523 13.5068 0.40738 14.6248 1.34666 15.5459C2.28595 16.467 3.41809 16.7553 4.70023 16.8185C6.02166 16.8924 9.98237 16.8924 11.3038 16.8185C12.5859 16.7588 13.7217 16.4705 14.6574 15.5459C15.5931 14.6248 15.8859 13.5068 15.9502 12.2447C16.0252 10.9439 16.0252 7.04863 15.9502 5.74785ZM14.2431 13.6404C13.9645 14.3295 13.4252 14.8603 12.7217 15.1381C11.6681 15.5494 9.16809 15.4545 8.0038 15.4545C6.83952 15.4545 4.33595 15.5459 3.28595 15.1381C2.58595 14.8639 2.04666 14.333 1.76452 13.6404C1.34666 12.6033 1.44309 10.1424 1.44309 8.99628C1.44309 7.85019 1.35024 5.38574 1.76452 4.35215C2.04309 3.66308 2.58238 3.13223 3.28595 2.85449C4.33952 2.44316 6.83952 2.53809 8.0038 2.53809C9.16809 2.53809 11.6717 2.44668 12.7217 2.85449C13.4217 3.12871 13.9609 3.65957 14.2431 4.35215C14.6609 5.38926 14.5645 7.85019 14.5645 8.99628C14.5645 10.1424 14.6609 12.6068 14.2431 13.6404Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 6621,
    fill: "white",
    transform: "translate(-870 -6374)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramlogo);
export default __webpack_public_path__ + "static/media/instagram logo.b9d9c6f4e7b268dca62721b7452d228d.svg";
export { ForwardRef as ReactComponent };